<div class="general-doc">
    <div>
        <h1>
            Research Arsenal Accessibility Statement
        </h1>
    </div>
    <div>
        <p>
            Research Arsenal <i>is committed to providing a website that is accessible to the widest possible
            audience, regardless of circumstance and ability. We aim to adhere as closely as possible to the
            Web Content Accessibility Guidelines (WCAG 2.0, Level AA), published by the World Wide Web
            Consortium (W3C). These guidelines explain how to make Web content more accessible for
            people with disabilities. Conformance with these guidelines will help make the web more user
            friendly to everyone. Whilst</i> Research Arsenal <i>strives to adhere to the guidelines and standards
            for accessibility, it is not always possible to do so in all areas of the website and we are currently
            working to achieve this. Be aware that due to the dynamic nature of the website, minor issues
            may occasionally occur as it is updated regularly. We are continually seeking out solutions that
            will bring all areas of the site up to the same level of overall web accessibility.
            If you have any comments and or suggestions relating to improving the accessibility of our site,
            please don&#39;t hesitate to contact us by clicking the button down below or email our accessibility 
            team directly at <a href="mailto: support@researcharsenal.com">support"&#64;researcharsenal.com</a>. Your
            feedback is greatly appreciated and will help us to make improvements.</i>
        </p>
        <br>
        <p>
            * Research Arsenal contains images and documents from the American Civil War. As such images may contain or describe graphic and disturbing content not suitable for all ages.
        </p>
        <p>
            ** Research Arsenal is continually researching images on this site as such not all images maybe fully researched.
        </p>
    </div>
    <div>
        <app-slant-button btnColor="green" (click)="openContactForm()" tooltip="Contact Us" btnIconClass="fa-comment-alt-lines">Contact Us</app-slant-button>
    </div>
</div>